import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Box } from '@mui/material';
import { PageTitle } from '../../PageTitle/PageTitle';
import LearningPathViewer from './LearningPathViewer';
import { getSignDocApi } from '../../../Services/api';
import './LearningPathPage.scss';
import { get } from 'lodash';

/**
 * Page component for displaying a learning path to users
 */
const LearningPathPage = () => {
  const { signDocId } = useParams();
  const [learningPathDoc, setLearningPathDoc] = useState(null);
  
  const init = async () => {
    try {
      // Fetch the learning path data
      const learningPathData = await getSignDocApi({ signDocId });
      if (learningPathData) {
        setLearningPathDoc(learningPathData);
      }
    } catch (error) {
      console.error('Error fetching learning path:', error);
    }
  };
  
  useEffect(() => {
    if (signDocId) {
      init();
    }
  }, [signDocId]);
  
  return (
    <div className="learning-path-page">
      <PageTitle 
        title={get(learningPathDoc, 'docName', 'Learning Path')}
        size="small"
        subTitle=""
        subTitleBold=""
        customComponent={null}
        noLogo={false}
      />
      <div className="scrollable-container">
        <Container maxWidth="lg" className="content">
            <LearningPathViewer signDocId={signDocId} />
        </Container>
      </div>
    </div>
  );
};

export default LearningPathPage; 